import {ModalContainer} from './Block'
import {Card} from 'react-bootstrap'
import Link from 'next/link'

const data =[
    {
        title:"Explore the Opportunity", 
        desc:"Join this group if you’re interested in learning to create a side income.", 
        link: "https://www.facebook.com/groups/ExploreOpportunity", 
        image:"/images/fb-group/img-explore-opportunity01.jpg"
    },
    {
        title:"Discover Shaklee’s Products", 
        desc:"Join this community to learn and discover more about Shaklee’s amazing products and the unique Shaklee difference.", 
        link:"https://www.facebook.com/groups/discovershaklee", 
        image:"/images/fb-group/img-discover-shaklee01.jpg"
    }
]

function JoinCommunity() {
    return (
        <ModalContainer
            icon={<img src="/images/fb-group/img-icon-fb-group01.svg" className="mr-2" width={30}/>}
            title="Join one of our facebook group"
            text={
                <div className="text-center">
                    <h5 className>Join our growing community on Facebook!</h5>
                    <div className="d-md-flex justify-content-between">
                        {data.map((data,idx) => (
                            <Card className="border-0 rounded-0 flex-1 m-3" key={idx}>
                                <Card.Img variant="top" src={data.image} className="rounded-0 m-auto w-75"/>
                                <Card.Body className="h7">
                                    <Card.Title>{data.title}</Card.Title>
                                    <Card.Text>{data.desc}</Card.Text>
                                    <Link href={data.link}><a className="text-blue" target="_blank" rel="noopener noreferrer">Join Group</a></Link>
                                </Card.Body>
                            </Card>
                        ))} 
                    </div>
                </div>
            }
        />
    )
}

export default JoinCommunity
